<template>
 <router-view></router-view>
</template>

<script>

import * as LayoutConsts from '@riseupil/base-ui/src/utils/layout-consts';
import BaseUI from '@riseupil/base-ui';
import { mapActions } from 'vuex';

export default {
  name: 'AllDiscounts',
  created() {
    this.setAppHeaderProps({
      backgroundColorVariant: LayoutConsts.COLOR_VARIANT.GREEN,
      logoColor: BaseUI.Colors.riseupWhite,
      textColor: BaseUI.Colors.riseupWhite,
    });
  },
  methods: {
    ...mapActions('appHeader', ['setAppHeaderProps']),
  },
};
</script>

<style lang="scss" scoped>

</style>
